import { createI18n } from 'vue-i18n'
import storage from '@/services/Storage.service'

export const lang_key = 'APP_LANG'
const default_lang_key_value = 'cs-CZ'
const fallback_locale_value = 'cs-CZ'

let loadedTranslations = null
export const getLoadedTranslations = () => loadedTranslations[storage.getItem(lang_key)]

const createI18nPlugin = async () => {
  const conf = {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  }

  const messages = await fetch('/translations.json', conf)
    .then(async (response) => await response.json())
    .catch((e) => console.log('e', e))

  loadedTranslations = messages

  function getQueryParams() {
    const params = new URLSearchParams(window.location.search)
    const paramsObject = {}

    for (const [key, value] of params) {
      paramsObject[key] = value
    }

    return paramsObject
  }

  const urlQueryParams = getQueryParams()
  const locale = urlQueryParams?.lang || storage.getItem(lang_key) || default_lang_key_value

  storage.setItem(lang_key, locale)

  const p = await createI18n({
    locale: locale, // set locale
    legacy: false, // enable to use auto vue inject
    fallbackLocale: fallback_locale_value, // set fallback locale
    messages, // set locale messages
    warnHtmlInMessage: false // disable XSS warning for HTML in messages
  })

  return p
}

export default createI18nPlugin
